import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FormCreateEmpleadoScheme } from "../../../Models/Schemas/form-create-empleado";
import { FORM_CREATE_EMPLEADO } from "../../../Constants/createEmpleado";
import Button from "../../Elements/Button/Button";
import { setErrorFormSimpleUtil } from "../../../Utilities/Forms/errors";
import useForm from "../../../Hooks/useForm";
import Input from "../../Elements/Input/Input";
import Loader from "../../Elements/Loader/Loader";
import useStore from "../../../useStore";
import { useToast } from "../../../Contexts/Toast/toast.provider";
import "./createEmpleado.css";
import { AREAS } from "../../../json/section/areas";
import { PUESTOS } from "../../../json/section/puestos";

const CreateEmpleado = () => {
  const showToast = useToast();
  const navigate = useNavigate();
  const { fetchCreateEmpleado, loadingCreateEmpleado, errorCreateEmpleado } = useStore();

  // TOKEN
  const loginData = JSON.parse(localStorage.getItem("logindata") || "{}");
  const token = loginData?.data?.token || "";

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    isValid,
    resetForm,
  } = useForm(FORM_CREATE_EMPLEADO, FormCreateEmpleadoScheme);

  const submit = async () => {
    try {
      /* await fetchCreateEmpleado(values, token);
      showToast("success", "Usuario creado correctamente");
      resetForm && resetForm();
      setTimeout(() => navigate("/"), 1500); */

      // crea empleado y recupera el numeroEmpleado
      const res = await fetchCreateEmpleado(values, token);
      const empleado = res?.empleado || res;
      /*  const numeroEmpleado = empleado?.numeroEmpleado; */
      const idEmpleado = empleado?.idEmpleado;

      showToast("success", "Usuario creado correctamente");
      showToast("info", "Contrato pendiente: súbelo en la edición del empleado");

      resetForm && resetForm();

      // Redirige a tu ruta de edición/detalle (ajústala a tu app)
      /*   if (numeroEmpleado) { */
      if (idEmpleado) {
        // ejemplo: /detalleEmpleado/:id
        /*  navigate(`/detalleEmpleado/${numeroEmpleado}`); */
        navigate(`/detalleEmpleado/${idEmpleado}`);
      } else {
        navigate("/");
      }
    } catch {
      // El toast de error lo maneja el store
    }
  };

  useEffect(() => {
    if (errorCreateEmpleado) {
      const message =
        errorCreateEmpleado instanceof Error
          ? errorCreateEmpleado.message
          : errorCreateEmpleado?.error || "Error desconocido";
      showToast("error", message);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorCreateEmpleado]);

  if (loadingCreateEmpleado) return <Loader />;

  return (
    <div className="container py-4 container-mh">
      <div className="row justify-content-center">
        <div className="col-12 col-md-10 col-lg-8">
          <div className="card shadow-lg border-0 rounded-4 p-4 create-empleado-card">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2 className="mb-0 fw-bold text-primary-emphasis">Alta de Empleado</h2>
              <Button
                text="Regresar"
                color="warning"
                fill
                action={() => navigate(-1)}
              />
            </div>

            <form className="alta-empleado-form-fields" autoComplete="off">
              <h5 className="mt-2 mb-2">Datos personales</h5>
              <div className="row g-3">
                <div className="col-md-6">
                  <Input
                    value={values.nombre}
                    label="Nombre"
                    onChange={handleChange("nombre")}
                    onBlur={handleBlur("nombre")}
                    error={setErrorFormSimpleUtil(errors, touched, "nombre")}
                    success={!setErrorFormSimpleUtil(errors, touched, "nombre")}
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    value={values.apellidoPaterno}
                    label="Apellido paterno"
                    onChange={handleChange("apellidoPaterno")}
                    onBlur={handleBlur("apellidoPaterno")}
                    error={setErrorFormSimpleUtil(errors, touched, "apellidoPaterno")}
                    success={!setErrorFormSimpleUtil(errors, touched, "apellidoPaterno")}
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    value={values.apellidoMaterno}
                    label="Apellido materno"
                    onChange={handleChange("apellidoMaterno")}
                    onBlur={handleBlur("apellidoMaterno")}
                    error={setErrorFormSimpleUtil(errors, touched, "apellidoMaterno")}
                    success={!setErrorFormSimpleUtil(errors, touched, "apellidoMaterno")}
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    value={values.curp}
                    label="CURP"
                    onChange={(e) => {
                      e.target.value = e.target.value.toUpperCase();
                      handleChange("curp")(e);
                    }}
                    onBlur={handleBlur("curp")}
                    error={setErrorFormSimpleUtil(errors, touched, "curp")}
                    success={!setErrorFormSimpleUtil(errors, touched, "curp")}
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    value={values.rfc}
                    label="RFC"
                    onChange={handleChange("rfc")}
                    onBlur={handleBlur("rfc")}
                    error={setErrorFormSimpleUtil(errors, touched, "rfc")}
                    success={!setErrorFormSimpleUtil(errors, touched, "rfc")}
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    value={values.fechaNacimiento}
                    label="Fecha de nacimiento"
                    type="date"
                    onChange={handleChange("fechaNacimiento")}
                    onBlur={handleBlur("fechaNacimiento")}
                    error={setErrorFormSimpleUtil(errors, touched, "fechaNacimiento")}
                    success={!setErrorFormSimpleUtil(errors, touched, "fechaNacimiento")}
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    value={values.numeroSeguroSocial}
                    label="Número de Seguro Social"
                    onChange={handleChange("numeroSeguroSocial")}
                    onBlur={handleBlur("numeroSeguroSocial")}
                    error={setErrorFormSimpleUtil(errors, touched, "numeroSeguroSocial")}
                    success={!setErrorFormSimpleUtil(errors, touched, "numeroSeguroSocial")}
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    value={values.gradoEstudios}
                    label="Grado de estudios"
                    onChange={handleChange("gradoEstudios")}
                    onBlur={handleBlur("gradoEstudios")}
                    error={setErrorFormSimpleUtil(errors, touched, "gradoEstudios")}
                    success={!setErrorFormSimpleUtil(errors, touched, "gradoEstudios")}
                  />
                </div>
              </div>

              <h6 className="mt-4 mb-2">Contacto de emergencia</h6>
              <div className="row g-3">
                <div className="col-md-4">
                  <Input
                    value={values.contactoEmergenciaNombre}
                    label="Nombre"
                    onChange={handleChange("contactoEmergenciaNombre")}
                    onBlur={handleBlur("contactoEmergenciaNombre")}
                    error={setErrorFormSimpleUtil(errors, touched, "contactoEmergenciaNombre")}
                    success={!setErrorFormSimpleUtil(errors, touched, "contactoEmergenciaNombre")}
                  />
                </div>
                <div className="col-md-2">
                  <Input
                    value={values.contactoEmergenciaParentesco}
                    label="Parentesco"
                    onChange={handleChange("contactoEmergenciaParentesco")}
                    onBlur={handleBlur("contactoEmergenciaParentesco")}
                    error={setErrorFormSimpleUtil(errors, touched, "contactoEmergenciaParentesco")}
                    success={!setErrorFormSimpleUtil(errors, touched, "contactoEmergenciaParentesco")}
                  />
                </div>
                <div className="col-md-2">
                  <Input
                    value={values.contactoEmergenciaTelefono}
                    label="Teléfono"
                    onChange={handleChange("contactoEmergenciaTelefono")}
                    onBlur={handleBlur("contactoEmergenciaTelefono")}
                    error={setErrorFormSimpleUtil(errors, touched, "contactoEmergenciaTelefono")}
                    success={!setErrorFormSimpleUtil(errors, touched, "contactoEmergenciaTelefono")}
                  />
                </div>
                <div className="col-md-2">
                  <Input
                    value={values.contactoEmergenciaTelefonoAlterno}
                    label="Tel. alterno"
                    onChange={handleChange("contactoEmergenciaTelefonoAlterno")}
                    onBlur={handleBlur("contactoEmergenciaTelefonoAlterno")}
                    error={setErrorFormSimpleUtil(errors, touched, "contactoEmergenciaTelefonoAlterno")}
                    success={!setErrorFormSimpleUtil(errors, touched, "contactoEmergenciaTelefonoAlterno")}
                  />
                </div>
                <div className="col-md-2">
                  <Input
                    value={values.contactoEmergenciaDireccion}
                    label="Dirección"
                    onChange={handleChange("contactoEmergenciaDireccion")}
                    onBlur={handleBlur("contactoEmergenciaDireccion")}
                    error={setErrorFormSimpleUtil(errors, touched, "contactoEmergenciaDireccion")}
                    success={!setErrorFormSimpleUtil(errors, touched, "contactoEmergenciaDireccion")}
                  />
                </div>
              </div>

              <hr />
              <h5 className="mb-2">Datos bancarios</h5>
              <div className="row g-3">
                <div className="col-md-4">
                  <Input
                    value={values.clabeNomina}
                    label="CLABE nómina"
                    onChange={handleChange("clabeNomina")}
                    onBlur={handleBlur("clabeNomina")}
                    error={setErrorFormSimpleUtil(errors, touched, "clabeNomina")}
                    success={!setErrorFormSimpleUtil(errors, touched, "clabeNomina")}
                  />
                </div>
                <div className="col-md-4">
                  <Input
                    value={values.bancoNomina}
                    label="Banco nómina"
                    onChange={handleChange("bancoNomina")}
                    onBlur={handleBlur("bancoNomina")}
                    error={setErrorFormSimpleUtil(errors, touched, "bancoNomina")}
                    success={!setErrorFormSimpleUtil(errors, touched, "bancoNomina")}
                  />
                </div>
                <div className="col-md-4">
                  <Input
                    value={values.titularNomina}
                    label="Titular nómina"
                    onChange={handleChange("titularNomina")}
                    onBlur={handleBlur("titularNomina")}
                    error={setErrorFormSimpleUtil(errors, touched, "titularNomina")}
                    success={!setErrorFormSimpleUtil(errors, touched, "titularNomina")}
                  />
                </div>
                <div className="col-md-4">
                  <Input
                    value={values.clabeAdicional}
                    label="CLABE adicional"
                    onChange={handleChange("clabeAdicional")}
                    onBlur={handleBlur("clabeAdicional")}
                    error={setErrorFormSimpleUtil(errors, touched, "clabeAdicional")}
                    success={!setErrorFormSimpleUtil(errors, touched, "clabeAdicional")}
                  />
                </div>
                <div className="col-md-4">
                  <Input
                    value={values.bancoAdicional}
                    label="Banco adicional"
                    onChange={handleChange("bancoAdicional")}
                    onBlur={handleBlur("bancoAdicional")}
                    error={setErrorFormSimpleUtil(errors, touched, "bancoAdicional")}
                    success={!setErrorFormSimpleUtil(errors, touched, "bancoAdicional")}
                  />
                </div>
                <div className="col-md-4">
                  <Input
                    value={values.titularAdicional}
                    label="Titular adicional"
                    onChange={handleChange("titularAdicional")}
                    onBlur={handleBlur("titularAdicional")}
                    error={setErrorFormSimpleUtil(errors, touched, "titularAdicional")}
                    success={!setErrorFormSimpleUtil(errors, touched, "titularAdicional")}
                  />
                </div>
              </div>

              <hr />
              <h5 className="mb-2">Datos del puesto</h5>
              <div className="row g-3">
                <div className="col-md-6">
                  <Input
                    value={values.numeroEmpleado}
                    label="Número de empleado"
                    onChange={handleChange("numeroEmpleado")}
                    onBlur={handleBlur("numeroEmpleado")}
                    error={setErrorFormSimpleUtil(errors, touched, "numeroEmpleado")}
                    success={values.numeroEmpleado && !setErrorFormSimpleUtil(errors, touched, "numeroEmpleado")}
                  />
                </div>
                <div className="col-md-6">
                  <div className="campo-select mb-3">
                    <label htmlFor="puesto" className="form-label">Puesto</label>
                    <select
                      id="puesto"
                      name="puesto"
                      value={values.puesto}
                      onChange={handleChange("puesto")}
                      onBlur={handleBlur("puesto")}
                      className={`form-select select-pro ${setErrorFormSimpleUtil(errors, touched, "puesto") ? "is-invalid" : ""}`}
                    >
                      <option value="">Selecciona puesto...</option>
                      {PUESTOS.map((puesto) => (
                        <option key={puesto} value={puesto}>{puesto}</option>
                      ))}
                    </select>
                    {setErrorFormSimpleUtil(errors, touched, "puesto") && (
                      <div className="invalid-feedback">
                        {setErrorFormSimpleUtil(errors, touched, "puesto")}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="campo-select mb-3">
                    <label htmlFor="area" className="form-label">Área</label>
                    <select
                      id="area"
                      name="area"
                      value={values.area}
                      onChange={handleChange("area")}
                      onBlur={handleBlur("area")}
                      className={`form-select select-pro ${setErrorFormSimpleUtil(errors, touched, "area") ? "is-invalid" : ""}`}
                    >
                      <option value="">Selecciona área...</option>
                      {AREAS.map((area) => (
                        <option key={area} value={area}>{area}</option>
                      ))}
                    </select>
                    {setErrorFormSimpleUtil(errors, touched, "area") && (
                      <div className="invalid-feedback">
                        {setErrorFormSimpleUtil(errors, touched, "area")}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <Input
                    value={values.fechaIngreso}
                    label="Fecha de ingreso"
                    type="date"
                    onChange={handleChange("fechaIngreso")}
                    onBlur={handleBlur("fechaIngreso")}
                    error={setErrorFormSimpleUtil(errors, touched, "fechaIngreso")}
                    success={!setErrorFormSimpleUtil(errors, touched, "fechaIngreso")}
                  />
                </div>
              </div>

              <div className="d-flex justify-content-end mt-4">
                <Button
                  text="Guardar"
                  color="green"
                  fill
                  action={submit}
                  disabled={!isValid}
                  classNames="alta-empleado-btn"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateEmpleado;
